(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["searchbox-with-predictive"] && !Shopify.designMode) return;
  try {
    const RECENT_SEARCH_KEY = 'sb-recent-searches';
const RECENT_SEARCH_LIMIT = 3;

function getRecentSearches() {
  try {
    const parsed = JSON.parse(localStorage.getItem(RECENT_SEARCH_KEY));
    if (!Array.isArray(parsed)) return [];
    const terms = parsed.filter((term) => typeof term === 'string' && term.trim() !== '').slice(0, RECENT_SEARCH_LIMIT);
    if (parsed.length !== terms.length) {
      localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(terms));
    }
    return terms;
  } catch (error) {
    return [];
  }
}

function saveRecentSearch(term) {
  const query = String(term || '').trim().replace(/\s+/g, ' ');
  if (!query) return;

  const next = [query].concat(
    getRecentSearches().filter((item) => item.toLowerCase() !== query.toLowerCase())
  ).slice(0, RECENT_SEARCH_LIMIT);

  localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(next));
  renderRecentSearches();
}

function renderRecentSearches() {
  const terms = getRecentSearches();

  document.querySelectorAll('[data-empty-search-panel]').forEach((panel) => {
    const group = panel.querySelector('[data-recent-searches-group]');
    const list = panel.querySelector('[data-recent-searches-list]');
    const sidebar = panel.querySelector('[data-empty-search-sidebar]');
    if (!group || !list) return;

    const searchUrl = panel.dataset.searchUrl || '/search';
    list.replaceChildren();

    terms.forEach((term) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `${searchUrl}?q=${encodeURIComponent(term)}`;
      link.textContent = term;
      item.appendChild(link);
      list.appendChild(item);
    });

    group.hidden = terms.length === 0;
    if (sidebar) {
      const hasPopular = Boolean(sidebar.querySelector('.emptysearchbox-group:not([data-recent-searches-group])'));
      sidebar.hidden = terms.length === 0 && !hasPopular;
    }
  });
}

function bindRecentSearchTracking() {
  if (document.documentElement.dataset.recentSearchBound === 'true') return;
  document.documentElement.dataset.recentSearchBound = 'true';

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[role="search"], .search-form')) return;
    const input = form.querySelector('input[name="q"], input[type="search"]');
    if (input) saveRecentSearch(input.value);
  });

  const firstPanel = document.querySelector('[data-empty-search-panel]');
  if (firstPanel && firstPanel.dataset.currentSearch) {
    saveRecentSearch(firstPanel.dataset.currentSearch);
  } else {
    renderRecentSearches();
  }
}

function isSearchPopdownOpen(popdown) {
  const details = popdown.closest('details');
  if (!details) return false;
  const openState = details.getAttribute('open');
  return details.hasAttribute('open') && openState !== 'false';
}

function syncEmptySearchPanel(popdown) {
  const input = popdown.querySelector('input[type="search"]');
  const panel = popdown.querySelector('[data-empty-search-panel]');
  if (!input || !panel) return;

  const hasQuery = input.value.trim().length > 0;
  const hovering = popdown.matches(':hover');
  const focused = popdown.contains(document.activeElement);
  const opened = isSearchPopdownOpen(popdown);
  popdown.classList.toggle('is-empty-search-visible', !hasQuery && (opened || hovering || focused));
}

function bindEmptySearchPanel(popdown) {
  if (popdown.dataset.emptySearchBound === 'true') return;
  if (!popdown.querySelector('[data-empty-search-panel]')) return;

  popdown.dataset.emptySearchBound = 'true';
  const onSync = () => syncEmptySearchPanel(popdown);
  const details = popdown.closest('details');

  popdown.addEventListener('mouseenter', onSync);
  popdown.addEventListener('mouseleave', onSync);
  popdown.addEventListener('focusin', onSync);
  popdown.addEventListener('focusout', () => {
    setTimeout(onSync, 0);
  });
  popdown.addEventListener('input', onSync);
  popdown.addEventListener('touchstart', onSync, { passive: true });

  if (details) {
    details.addEventListener('toggle', onSync);
    details.addEventListener('click', onSync);
    new MutationObserver(onSync).observe(details, { attributes: true, attributeFilter: ['open'] });
  }

  onSync();
}

function initEmptySearchPanels() {
  document.querySelectorAll('[data-popdown]').forEach(bindEmptySearchPanel);
  bindRecentSearchTracking();
  renderRecentSearches();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEmptySearchPanels);
} else {
  initEmptySearchPanels();
}

document.addEventListener('shopify:section:load', initEmptySearchPanels);
  } catch(e) { console.error(e); }
})();

})();
